import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import "./login.css";
import LogoRadioPalamos from "../../assets/logos/imgLogoRadioPalamos.png";
// Main components
import MainTopBar from "../../components/main/topbar/topbar";
import MainBottomBar from "../../components/main/bottombar/bottombar";
// Components
import CommonButton from "../../components/common/button/button";
import Loading from "../../components/common/loading/loading";
// Actions
import * as authActions from "../../redux/actions/auth";
// Utils
import { getToastOpt } from '../../utils/utils';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  // States
  const [, setRender] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({});
  // Selectors
  const user = useSelector(state => state.authReducer.user);

  useEffect(() => {

    // Attaching the event listener function to window's resize event
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    if (!user) return;
    // User is logged in, redirect to the initial page
    // if (user.grants.live) {

    // } else {

    // }
    navigate('/news');
  }, [user]);  

  const onResize = (e) => {
    //console.log("onResize", e);
    setRender((prev) => prev + 1); // Re-render
  };

  /*
   * Login
   */
  const handleLogin = async (e) => {
    e.preventDefault(); // Avoids refreshing the page
    setIsLoading(true);

    dispatch(authActions.login(form['email'], form['password'])).then(
      (response) => {
        setIsLoading(false);
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error d'autenticació`,
          description: err,
          status: "error",
        }));
      }
    );
  }

  const handleChange = (evt) => {
    let value;
    const fieldName = evt.currentTarget.name;
    if ([`active`].includes(fieldName)) {
      value = evt.currentTarget.checked;
    } else {
      const fieldType = evt.currentTarget.getAttribute(`data-type`);
      value = evt.currentTarget.value;
      if (fieldType === `int`) {
        value = parseInt(value);
      }
    }

    setForm({
      ...form,
      [fieldName]: value,
    });
  };

  return (
    <div className="page">
      <div className="page-outer">
        <MainTopBar />
        <div className="page-inner">
          <div id="login-wrapper">
            <div id="login-header"></div>
            <div id="login-body">

              <div id="login-title-wrapper">        
                <div id="login-title">
                  Ràdio Palamós
                </div>
                <img
                  src={LogoRadioPalamos}
                  id="login-logo-radiopalamos"
                  alt="RÀDIO PALAMÓS"
                />                
                <div id="login-subtitle">
                  Panell d'administració de l'app de Ràdio Palamós
                </div>
              </div>

              <form onSubmit={handleLogin} id="login-form">
                <div className="login-form-inner">
                  <FormControl isRequired>
                    <FormLabel fontSize="sm" className="login-form-label">
                      Usuari
                    </FormLabel>
                    <Input
                      className="login-form-field"
                      placeholder="Email"
                      name="email"
                      data-type={`string`}
                      onChange={handleChange}
                      value={form[`email`] ? form[`email`] : ``}
                      type="email"
                    />
                  </FormControl>
                  <FormControl isRequired mt={4}>
                    <FormLabel fontSize="sm" className="login-form-label">
                      Password
                    </FormLabel>
                    <Input
                      className="login-form-field"
                      placeholder="Password"
                      name="password"
                      data-type={`string`}
                      onChange={handleChange}
                      value={form[`password`] ? form[`password`] : ``}
                      type="password"
                    />
                  </FormControl>
                </div>
                <div className="login-form-buttons">
                  <CommonButton
                    onClick={() => {}}
                    style={{
                      width: "100%",
                      marginTop: 50
                    }}
                    type={'submit'}
                    disabled={false}
                  >
                    LOGIN
                  </CommonButton>                  
                </div>
              </form>

            </div>
          </div>
        </div>
        <MainBottomBar />
        {isLoading && <Loading />}
      </div>
    </div>
  );
};

export default Login;
